import { eventQBus } from "../types/EventQBus";

const OBSERVER_OPTIONS = {
  root: null,
  rootMargin: "300px 0px 300px 0px",
  threshold: 0,
};

function onIntersect(entries: IntersectionObserverEntry[], observer: IntersectionObserver) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      const tile = entry.target as HTMLElement;

      eventQBus.emit("ftfind.tile.load", {
        target: tile,
      });

      observer.unobserve(tile);
    }
  });
}

function onTileListLoaded() {
  let lazyTiles;

  lazyTiles = document.querySelectorAll("article[data-preload=false][data-loaded=false]");

  const observer = new IntersectionObserver(onIntersect, OBSERVER_OPTIONS);

  Array.from(lazyTiles).forEach((tile) => observer.observe(tile));
}

export function registerTileLoading() {
  onTileListLoaded(); /*                                                                            */
  eventQBus.on("ftfind.tilelist.loaded", () => onTileListLoaded());
}
